import { h, Component } from 'preact';
import { hopplerApi } from '../../../../constants';

export class CommissionAgreement extends Component<any, any> {

  // These static pages are nothing more than a looking glass
  // To our existing express static pages.
  render() {
    return(
      <div className="">
        <div className="container-fluid">
          <div className="row">
            
            <div className="col-12">
              <iframe className="w-100 hi-kumita__static-page-frame"
                src="/frameable/terms#commissionagreement">

              </iframe>
            </div>
            
          </div>
        </div>
      </div>
    );
  }
}